import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-header" }
const _hoisted_2 = { class: "list-header__left" }
const _hoisted_3 = { class: "list-header__branding" }
const _hoisted_4 = { class: "list-header__hospital" }
const _hoisted_5 = { class: "list-header__right" }
const _hoisted_6 = { class: "list-header__user" }
const _hoisted_7 = { class: "list-header__avatar" }
const _hoisted_8 = { class: "list-header__user-name" }

import { computed, ref } from "vue";

interface Props {
  hospitalName?: string;
  userName?: string;
}

interface Emits {
  (e: "settings"): void;
  (e: "logout"): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientListHeader',
  props: {
    hospitalName: { default: "Community Hospital" },
    userName: { default: "Alex Rodriguez" }
  },
  emits: ["settings", "logout"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showLogoutDialog = ref(false);

const userInitials = computed(() => {
  const names = props.userName.split(" ");
  if (names.length >= 2) {
    return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
  }
  return props.userName.substring(0, 2).toUpperCase();
});

const handleSettings = () => {
  emit("settings");
};

const confirmLogout = () => {
  showLogoutDialog.value = false;
  emit("logout");
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"list-header__icon\" data-v-526d4a63><div class=\"list-header__icon-grid\" data-v-526d4a63><div class=\"list-header__icon-cell\" data-v-526d4a63></div><div class=\"list-header__icon-cell\" data-v-526d4a63></div><div class=\"list-header__icon-cell\" data-v-526d4a63></div><div class=\"list-header__icon-cell\" data-v-526d4a63></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.hospitalName), 1),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "list-header__title" }, "Virtual Nurse", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_btn, {
        variant: "text",
        class: "list-header__settings-btn",
        icon: "",
        size: "small",
        onClick: handleSettings
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "#000000"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-cog-outline", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_tooltip, {
            activator: "parent",
            location: "bottom"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Settings", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        variant: "text",
        class: "list-header__logout-btn",
        icon: "",
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showLogoutDialog.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "#000000"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("mdi-logout", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_tooltip, {
            activator: "parent",
            location: "bottom"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Logout", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(userInitials.value), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.userName), 1)
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showLogoutDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showLogoutDialog).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "logout-dialog__title" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" Confirm Logout ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "logout-dialog__text" }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" Are you sure you want to log out? ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "logout-dialog__actions" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showLogoutDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "#6B46C1",
                  variant: "flat",
                  onClick: confirmLogout
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" Logout ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})